// src/utils/parcelLayerCache.js

let cachedLayer = null;

export const getParcelLayerCache = () => {
  if (cachedLayer?.destroyed) {
    console.warn("⚠️ Cached layer is destroyed. Clearing...");
    cachedLayer = null;
  }
  return cachedLayer;
};

export const setParcelLayerCache = (layer) => {
  if (layer && !layer.destroyed) {
    cachedLayer = layer;
  }
};

export const clearParcelLayerCache = () => {
  cachedLayer = null;
};
